import styled, { css } from "styled-components/macro";
import { motion } from "framer-motion";

import {
  colors,
  space,
  borderRadius,
  breakpoint,
  boxShadow,
  zIndex,
  fontSize,
  titlefontStyle,
} from "shared/styles/constants";

export const SideMenuContainer = styled(motion.nav)`
  overflow: hidden;

  position: sticky;
  top: ${space.l};

  margin-left: ${space.l};

  height: fit-content;
  max-height: calc(100vh - ${space.l} * 2);
  overflow-y: auto;

  background-color: ${colors.black};
  border-radius: ${borderRadius.m};

  -ms-overflow-style: none; // Edge
  scrollbar-width: none; // Firefox

  // Chrome, Safari and Opera
  &::-webkit-scrollbar {
    display: none;
  }

  ${breakpoint("m", "down")} {
    position: relative;
    top: 0;

    width: inherit;
    max-width: 100%;

    max-height: none;

    margin: 0 ${space.s};
  }
`;

interface MenuProps {
  isOpen?: boolean;
}

export interface StyledSideMenuProps {
  accentColor?: string;
  isMobile?: boolean;
}

export const MenuHeader = styled.button.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => {
    return defaultValidatorFn(prop);
  },
})<StyledSideMenuProps>`
  position: sticky;
  top: 0;
  z-index: ${zIndex.above};

  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  min-height: 36px;
  padding: calc(${space.m} - 2px) ${space.m};
  margin: 0;

  background-color: ${colors.grey1};

  box-shadow: ${boxShadow.l};

  ${fontSize.l}
  ${titlefontStyle.bold}
  text-align: inherit;
  text-decoration: none;

  outline: none;

  ${({ accentColor, isMobile }: StyledSideMenuProps) =>
    accentColor &&
    !isMobile &&
    css`
      &::after {
        content: "";

        position: absolute;
        bottom: 0;
        left: 0;

        height: 3px;
        width: 100%;
        background: ${accentColor};
      }
    `}
`;

export const MenuContent = styled.ul<MenuProps>`
  display: flex;
  flex-direction: column;

  list-style: none;
  padding: 0;
  margin: 0;

  ${breakpoint("m", "down")} {
    display: ${({ isOpen }) => (isOpen ? "block" : "none")};
  }
`;
